import { extendTheme } from "@chakra-ui/react";
const REIVColor = "#00adee";

export const vicformsTheme = extendTheme({
  fonts: {
    heading: "DM Sans",
    body: "DM Sans",
  },
  colors: {
    primary: {
      "50": "#E5F8FF",
      "100": "#B8ECFF",
      "200": "#8ADFFF",
      "300": "#5CD3FF",
      "400": "#2EC6FF",
      "500": REIVColor,
      "600": "#0095CC",
      "700": "#007099",
      "800": "#004A66",
      "900": "#002533",
    },
  },
  components: {
    Input: {
      parts: ["field"],
      defaultProps: {
        focusBorderColor: "primary.500",
        variant: "filled",
      },
    },
  },
});
